export const TOAST_OPTIONS = {
  position: "top-right",
  autoClose: 2000,
  pauseOnHover: true,
  draggable: true,
  theme: "dark",
}
export const OPENSEA_API_KEY = process.env.REACT_APP_OS_API_KEY
export const INFINITY_NUMBER = 600000000